import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import Space from 'antd/lib/space';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

interface CLIEditActionsProps {
    itemId: string;
    deleteIsLoading: boolean;
    onConfirmDelete: (id: string) => void;
    onEditChecklistItem: (id: string) => void;
    disableEditButton: boolean;
}

const CLIEditActions: React.FC<CLIEditActionsProps> = (props: CLIEditActionsProps) => {
    const [deletePopoverVisible, setDeletePopoverVisible] = React.useState(false);

    return (
        <Space align="center">
            <Popconfirm
                defaultOpen={props.deleteIsLoading}
                open={deletePopoverVisible || props.deleteIsLoading}
                title="Are you sure you want to delete this item? It will be deleted from all active and future releases."
                okText="Yes, delete."
                okButtonProps={{ loading: props.deleteIsLoading }}
                onConfirm={() => props.onConfirmDelete(props.itemId)}
                onCancel={() => setDeletePopoverVisible(false)}
                overlayStyle={{ maxWidth: 400 }}
                placement="topRight"
            >
                <Button
                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                    type="link"
                    onClick={() => {
                        setDeletePopoverVisible(true);
                    }}
                    style={{ width: 24, height: 24 }}
                />
            </Popconfirm>
            <Button
                disabled={props.disableEditButton}
                icon={<EditOutlined />}
                type="link"
                onClick={() => props.onEditChecklistItem(props.itemId)}
                style={{ width: 24, height: 24 }}
            />
        </Space>
    );
};

export default CLIEditActions;
